// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { GetWaterfallSummary_GiftTaxSummaryFragment, GetWaterfallSummary_TaxSummaryV2Fragment, GetWaterfallSummary_EstateWaterfallVizNodeFragment, GetWaterfallSummary_EstateWaterfallVizEdgeFragment, GetWaterfallSummary_TransferLogFragment, GetWaterfallSummary_EstateWaterfallHypotheticalTransferFragment } from '../../../graphql/GetWaterfallSummary.generated';
import { HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment } from '../../../../../utils/hypotheticalTransfers/graphql/HypotheticalTransferUtils.generated';
import { EstateWaterfall_EstateWaterfallHypotheticalTransferFragment } from '../../../graphql/EstateWaterfall.generated';
import { TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment, TenantPresentationConfiguration_HouseholdFragment } from '../../../../presentation/graphql/TenantPresentationConfiguration.generated';
import { gql } from '@apollo/client';
import { GetWaterfallSummary_GiftTaxSummaryFragmentDoc, GetWaterfallSummary_TaxSummaryV2FragmentDoc, GetWaterfallSummary_EstateWaterfallVizNodeFragmentDoc, GetWaterfallSummary_EstateWaterfallVizEdgeFragmentDoc, GetWaterfallSummary_TransferLogFragmentDoc, GetWaterfallSummary_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../graphql/GetWaterfallSummary.generated';
import { HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../../../utils/hypotheticalTransfers/graphql/HypotheticalTransferUtils.generated';
import { EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../graphql/EstateWaterfall.generated';
import { TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc, TenantPresentationConfiguration_HouseholdFragmentDoc } from '../../../../presentation/graphql/TenantPresentationConfiguration.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment = { __typename?: 'EstateWaterfallViz', _cacheKey: string, firstDeathInsuranceBenefit: CurrencyUSD, firstDeathInEstateInsuranceBenefit: CurrencyUSD, firstDeathOutOfEstateInsuranceBenefit: CurrencyUSD, secondDeathInsuranceBenefit?: CurrencyUSD | null, secondDeathInEstateInsuranceBenefit?: CurrencyUSD | null, secondDeathOutOfEstateInsuranceBenefit?: CurrencyUSD | null, firstDeathRemainingLifetimeExemption: CurrencyUSD, secondDeathRemainingLifetimeExemption: CurrencyUSD, lifetimeExemptionAppliedTowardsGiftTax?: CurrencyUSD | null, beforeFirstDeathTaxSummaryV2?: (
    { __typename?: 'GiftTaxSummary' }
    & GetWaterfallSummary_GiftTaxSummaryFragment
  ) | null, firstDeathTaxSummaryV2: (
    { __typename?: 'TaxSummaryV2' }
    & GetWaterfallSummary_TaxSummaryV2Fragment
  ), secondDeathTaxSummaryV2?: (
    { __typename?: 'TaxSummaryV2' }
    & GetWaterfallSummary_TaxSummaryV2Fragment
  ) | null, nodes: Array<(
    { __typename?: 'EstateWaterfallVizNode' }
    & GetWaterfallSummary_EstateWaterfallVizNodeFragment
  )>, edges: Array<(
    { __typename?: 'EstateWaterfallVizEdge' }
    & GetWaterfallSummary_EstateWaterfallVizEdgeFragment
  )>, growthProfile: (
    { __typename?: 'GrowthProfile' }
    & EstateWaterfallComparisonTrowser_GrowthProfileFragment
  ), transferLog: Array<(
    { __typename?: 'EstateWaterfallTransfer' }
    & GetWaterfallSummary_TransferLogFragment
  )>, materializedInputParams: { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null } };

export type EstateWaterfallComparisonTrowser_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, kind?: Types.EstateWaterfallKind | null, household: { __typename?: 'Household', id: string, displayName: string, isTwoGrantor: boolean, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, displayGivenName: string, remainingLifetimeExclusion: CurrencyUSD }> }, hypotheticalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment
        & GetWaterfallSummary_EstateWaterfallHypotheticalTransferFragment
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, displayName: string }, parent?: { __typename?: 'EstateWaterfall', id: string, displayName: string } | null };

export type EstateWaterfallComparisonTrowser_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, displayName: string, isDefault: boolean, exemptionGrowthRate: Percent, assetGrowthReturn?: Percent | null };

export type EstateWaterfallComparisonTrowserQueryVariables = Types.Exact<{
  firstWaterfallVisualization: Types.EstateWaterfallProjectionInput;
  firstWaterfallId: Types.Scalars['ID']['input'];
  useFirstWaterfallVisualization: Types.Scalars['Boolean']['input'];
  secondWaterfallVisualization: Types.EstateWaterfallProjectionInput;
  secondWaterfallId: Types.Scalars['ID']['input'];
  useSecondWaterfallVisualization: Types.Scalars['Boolean']['input'];
  thirdWaterfallVisualization: Types.EstateWaterfallProjectionInput;
  thirdWaterfallId: Types.Scalars['ID']['input'];
  useThirdWaterfallVisualization: Types.Scalars['Boolean']['input'];
  fourthWaterfallVisualization: Types.EstateWaterfallProjectionInput;
  fourthWaterfallId: Types.Scalars['ID']['input'];
  useFourthWaterfallVisualization: Types.Scalars['Boolean']['input'];
  householdId: Types.Scalars['ID']['input'];
}>;


export type EstateWaterfallComparisonTrowserQuery = { __typename?: 'Query', tenantInformation: { __typename?: 'TenantInformation', id: string, disclosuresConfiguration?: (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment
    ) | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household', id: string }
        & TenantPresentationConfiguration_HouseholdFragment
      ) | null } | null> | null }, firstEstateWaterfall?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall', visualizationWithProjections: (
          { __typename?: 'EstateWaterfallViz' }
          & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
        ) }
        & EstateWaterfallComparisonTrowser_EstateWaterfallFragment
      ) | null } | null> | null }, secondEstateWaterfall?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall', visualizationWithProjections: (
          { __typename?: 'EstateWaterfallViz' }
          & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
        ) }
        & EstateWaterfallComparisonTrowser_EstateWaterfallFragment
      ) | null } | null> | null }, thirdEstateWaterfall?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall', visualizationWithProjections: (
          { __typename?: 'EstateWaterfallViz' }
          & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
        ) }
        & EstateWaterfallComparisonTrowser_EstateWaterfallFragment
      ) | null } | null> | null }, fourthEstateWaterfall?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall', visualizationWithProjections: (
          { __typename?: 'EstateWaterfallViz' }
          & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
        ) }
        & EstateWaterfallComparisonTrowser_EstateWaterfallFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EstateWaterfallComparisonTrowser: 'EstateWaterfallComparisonTrowser' as const
  },
  Fragment: {
    EstateWaterfallComparisonTrowser_EstateWaterfallViz: 'EstateWaterfallComparisonTrowser_EstateWaterfallViz' as const,
    EstateWaterfallComparisonTrowser_EstateWaterfall: 'EstateWaterfallComparisonTrowser_EstateWaterfall' as const,
    EstateWaterfallComparisonTrowser_GrowthProfile: 'EstateWaterfallComparisonTrowser_GrowthProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallComparisonTrowser_GrowthProfileFragmentDoc = gql`
    fragment EstateWaterfallComparisonTrowser_GrowthProfile on GrowthProfile {
  id
  displayName
  isDefault
  exemptionGrowthRate
  assetGrowthReturn
}
    `;
export const EstateWaterfallComparisonTrowser_EstateWaterfallVizFragmentDoc = gql`
    fragment EstateWaterfallComparisonTrowser_EstateWaterfallViz on EstateWaterfallViz {
  _cacheKey
  firstDeathInsuranceBenefit
  firstDeathInEstateInsuranceBenefit
  firstDeathOutOfEstateInsuranceBenefit
  secondDeathInsuranceBenefit
  secondDeathInEstateInsuranceBenefit
  secondDeathOutOfEstateInsuranceBenefit
  firstDeathRemainingLifetimeExemption
  secondDeathRemainingLifetimeExemption
  lifetimeExemptionAppliedTowardsGiftTax
  beforeFirstDeathTaxSummaryV2 {
    ...GetWaterfallSummary_GiftTaxSummary
  }
  firstDeathTaxSummaryV2 {
    ...GetWaterfallSummary_TaxSummaryV2
  }
  secondDeathTaxSummaryV2 {
    ...GetWaterfallSummary_TaxSummaryV2
  }
  nodes {
    ...GetWaterfallSummary_EstateWaterfallVizNode
  }
  edges {
    ...GetWaterfallSummary_EstateWaterfallVizEdge
  }
  growthProfile {
    ...EstateWaterfallComparisonTrowser_GrowthProfile
  }
  transferLog {
    ...GetWaterfallSummary_TransferLog
  }
  materializedInputParams {
    firstGrantorDeathYear
    secondGrantorDeathYear
    selectedGrowthProfile {
      id
      displayName
    }
  }
}
    ${GetWaterfallSummary_GiftTaxSummaryFragmentDoc}
${GetWaterfallSummary_TaxSummaryV2FragmentDoc}
${GetWaterfallSummary_EstateWaterfallVizNodeFragmentDoc}
${GetWaterfallSummary_EstateWaterfallVizEdgeFragmentDoc}
${EstateWaterfallComparisonTrowser_GrowthProfileFragmentDoc}
${GetWaterfallSummary_TransferLogFragmentDoc}`;
export const EstateWaterfallComparisonTrowser_EstateWaterfallFragmentDoc = gql`
    fragment EstateWaterfallComparisonTrowser_EstateWaterfall on EstateWaterfall {
  id
  displayName
  household {
    id
    displayName
    isTwoGrantor
    possiblePrimaryClients {
      id
      displayName
      displayGivenName
      remainingLifetimeExclusion
    }
  }
  hypotheticalTransfers {
    edges {
      node {
        ...HypotheticalTransferUtils_EstateWaterfallHypotheticalTransfer
        ...GetWaterfallSummary_EstateWaterfallHypotheticalTransfer
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  firstGrantorDeath {
    id
    displayName
  }
  firstGrantorDeathYear
  secondGrantorDeathYear
  kind
  parent {
    id
    displayName
  }
}
    ${HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragmentDoc}
${GetWaterfallSummary_EstateWaterfallHypotheticalTransferFragmentDoc}
${EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc}`;
export const EstateWaterfallComparisonTrowserDocument = gql`
    query EstateWaterfallComparisonTrowser($firstWaterfallVisualization: EstateWaterfallProjectionInput!, $firstWaterfallId: ID!, $useFirstWaterfallVisualization: Boolean!, $secondWaterfallVisualization: EstateWaterfallProjectionInput!, $secondWaterfallId: ID!, $useSecondWaterfallVisualization: Boolean!, $thirdWaterfallVisualization: EstateWaterfallProjectionInput!, $thirdWaterfallId: ID!, $useThirdWaterfallVisualization: Boolean!, $fourthWaterfallVisualization: EstateWaterfallProjectionInput!, $fourthWaterfallId: ID!, $useFourthWaterfallVisualization: Boolean!, $householdId: ID!) {
  tenantInformation {
    id
    disclosuresConfiguration {
      ...TenantPresentationConfiguration_TenantDisclaimerConfiguration
    }
  }
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        ...TenantPresentationConfiguration_Household
      }
    }
  }
  firstEstateWaterfall: estateWaterfalls(where: {id: $firstWaterfallId}) @include(if: $useFirstWaterfallVisualization) {
    edges {
      node {
        ...EstateWaterfallComparisonTrowser_EstateWaterfall
        visualizationWithProjections(input: $firstWaterfallVisualization) {
          ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
        }
      }
    }
  }
  secondEstateWaterfall: estateWaterfalls(where: {id: $secondWaterfallId}) @include(if: $useSecondWaterfallVisualization) {
    edges {
      node {
        ...EstateWaterfallComparisonTrowser_EstateWaterfall
        visualizationWithProjections(input: $secondWaterfallVisualization) {
          ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
        }
      }
    }
  }
  thirdEstateWaterfall: estateWaterfalls(where: {id: $thirdWaterfallId}) @include(if: $useThirdWaterfallVisualization) {
    edges {
      node {
        ...EstateWaterfallComparisonTrowser_EstateWaterfall
        visualizationWithProjections(input: $thirdWaterfallVisualization) {
          ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
        }
      }
    }
  }
  fourthEstateWaterfall: estateWaterfalls(where: {id: $fourthWaterfallId}) @include(if: $useFourthWaterfallVisualization) {
    edges {
      node {
        ...EstateWaterfallComparisonTrowser_EstateWaterfall
        visualizationWithProjections(input: $fourthWaterfallVisualization) {
          ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
        }
      }
    }
  }
}
    ${TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc}
${TenantPresentationConfiguration_HouseholdFragmentDoc}
${EstateWaterfallComparisonTrowser_EstateWaterfallFragmentDoc}
${EstateWaterfallComparisonTrowser_EstateWaterfallVizFragmentDoc}`;

/**
 * __useEstateWaterfallComparisonTrowserQuery__
 *
 * To run a query within a React component, call `useEstateWaterfallComparisonTrowserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallComparisonTrowserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateWaterfallComparisonTrowserQuery({
 *   variables: {
 *      firstWaterfallVisualization: // value for 'firstWaterfallVisualization'
 *      firstWaterfallId: // value for 'firstWaterfallId'
 *      useFirstWaterfallVisualization: // value for 'useFirstWaterfallVisualization'
 *      secondWaterfallVisualization: // value for 'secondWaterfallVisualization'
 *      secondWaterfallId: // value for 'secondWaterfallId'
 *      useSecondWaterfallVisualization: // value for 'useSecondWaterfallVisualization'
 *      thirdWaterfallVisualization: // value for 'thirdWaterfallVisualization'
 *      thirdWaterfallId: // value for 'thirdWaterfallId'
 *      useThirdWaterfallVisualization: // value for 'useThirdWaterfallVisualization'
 *      fourthWaterfallVisualization: // value for 'fourthWaterfallVisualization'
 *      fourthWaterfallId: // value for 'fourthWaterfallId'
 *      useFourthWaterfallVisualization: // value for 'useFourthWaterfallVisualization'
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useEstateWaterfallComparisonTrowserQuery(baseOptions: Apollo.QueryHookOptions<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>(EstateWaterfallComparisonTrowserDocument, withFetchPolicyContext(options));
      }
export function useEstateWaterfallComparisonTrowserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>(EstateWaterfallComparisonTrowserDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateWaterfallComparisonTrowserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>(EstateWaterfallComparisonTrowserDocument, withFetchPolicyContext(options));
        }
export type EstateWaterfallComparisonTrowserQueryHookResult = ReturnType<typeof useEstateWaterfallComparisonTrowserQuery>;
export type EstateWaterfallComparisonTrowserLazyQueryHookResult = ReturnType<typeof useEstateWaterfallComparisonTrowserLazyQuery>;
export type EstateWaterfallComparisonTrowserSuspenseQueryHookResult = ReturnType<typeof useEstateWaterfallComparisonTrowserSuspenseQuery>;
export type EstateWaterfallComparisonTrowserQueryResult = Apollo.QueryResult<EstateWaterfallComparisonTrowserQuery, EstateWaterfallComparisonTrowserQueryVariables>;